import { render, staticRenderFns } from "./BImageGroup.vue?vue&type=template&id=1d735f78&scoped=true&"
import script from "./BImageGroup.vue?vue&type=script&lang=js&"
export * from "./BImageGroup.vue?vue&type=script&lang=js&"
import style0 from "./BImageGroup.vue?vue&type=style&index=0&id=1d735f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d735f78",
  null
  
)

export default component.exports